import GuidePartiList from './GuidePartiList';

export default GuidePartiList;
